export enum IconButtonType {
    DEFAULT = 'default',
    PRIMARY = 'primary',
    GHOST = 'ghost',
}
